import { useEffect } from "react";
import { getNodesBounds, useReactFlow } from "@xyflow/react";
import { useEditorStore } from "../../store/editor-store";

function isEditingTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  return target.isContentEditable || target.matches("input, textarea, select, [role='textbox']");
}

export function useCanvasShortcuts(): void {
  const { fitBounds } = useReactFlow();

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (isEditingTarget(event.target)) return;
      const command = event.metaKey || event.ctrlKey;
      const store = useEditorStore.getState();

      if (command && event.key.toLowerCase() === "z") {
        event.preventDefault();
        if (event.shiftKey) store.redo();
        else store.undo();
      } else if (command && event.key.toLowerCase() === "y") {
        event.preventDefault();
        store.redo();
      } else if (command && event.key.toLowerCase() === "c") {
        event.preventDefault();
        store.copySelected();
      } else if (command && event.key.toLowerCase() === "v") {
        event.preventDefault();
        store.pasteClipboard();
      } else if (command && event.key.toLowerCase() === "a") {
        event.preventDefault();
        store.selectAll();
      } else if (command && event.key.toLowerCase() === "d") {
        event.preventDefault();
        store.duplicateSelected();
      } else if (command && event.key === "0") {
        event.preventDefault();
        if (store.nodes.length) {
          void fitBounds(getNodesBounds(store.nodes), { padding: 0.18, duration: 260 });
        }
      } else if (event.key === "Backspace" || event.key === "Delete") {
        event.preventDefault();
        store.deleteSelected();
      } else if (event.key === "Escape") {
        store.clearSelection();
      }
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [fitBounds]);
}
